import React, { useState, useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import api from '../../service/api';


import calc from './calc';
import Information from './Information';

const Dashboard = () => {
    var startDate = new Date();
    startDate.setDate(1);
    startDate.setHours(0);
    startDate.setMinutes(0);
    startDate.setSeconds(0);
    startDate.setMilliseconds(0);

    var endDate = new Date();
    endDate.setMonth(endDate.getMonth() + 1);
    endDate.setDate(0);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    endDate.setMilliseconds(0);

    const emptyFilter = {
        startDate: startDate,
        endDate: endDate,
        truck: 'all',
    }

    const [filter, setFilter] = useState(emptyFilter);
    const [trucks, setTrucks ] = useState([]);
    const [filterTruck, setFilterTruck] = useState([{ label: 'Todos', value: 'all' }]);
    const [dashboardData, setDashboardData] = useState({});
    const [loading, setLoading] = useState(true);

    const listDashboardInfo = () => {
        setLoading(true);
        api().post(`/dashboard`, {
            startDate: filter.startDate.getTime(),
            endDate: filter.endDate.getTime(),
            truck: filter.truck !== 'all' ? trucks.find(({ plate }) => plate == filter.truck)?.code || 'all' : 'all'
        }).then(response => {
            setLoading(false);
            const { expenses, travels, fuelConsumptionByDriver } = response.data.data;
            setDashboardData({...calc(travels, expenses, filter.truck), fuelConsumptionByDriver});
        });
    }

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const onInputFilterChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _filter = { ...filter };
        _filter[`${name}`] = val;

        window.localStorage.setItem(`@ctruckFilter${capitalizeFirstLetter(name)}`, typeof val == 'object' ? val.getTime() : val)

        setFilter(_filter);
    }

    const listTrucks = () => {
        api().get('truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                var filter = [{ label: 'Todos', value: 'all' }];
                setTrucks(response.data.data);
                response.data.data.forEach(truck => {
                    filter.push({ label: truck.plate, value: truck.plate });
                });
                setFilterTruck(filter);
            }
        });
    }

    const Filter = () => (
        <div className="card">
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center mb-6">
                <h5 className="m-0">Dashboard</h5>
            </div>

            <div className="grid">
                <div className="field mt-2 lg:col-3">
                    <span className="p-float-label">
                        <Calendar value={filter.startDate} style={{ width: "100%" }} onChange={(e) => onInputFilterChange(e, 'startDate')} dateFormat='dd/mm/yy' locale='pt-br' />
                        <label>Data Inicial</label>
                    </span>
                </div>
                <div className="field mt-2 lg:col-3">
                    <span className="p-float-label">
                        <Calendar value={filter.endDate} style={{ width: "100%" }} onChange={(e) => onInputFilterChange(e, 'endDate')} dateFormat='dd/mm/yy' locale='pt-br' />
                        <label>Data Final</label>
                    </span>
                </div>
                <div className="field mt-2 lg:col-3">
                    <span className="p-float-label">
                    <Dropdown value={filter.truck} style={{ width: "100%" }} id="truckFilter" options={filterTruck} onChange={(e) => {
                       onInputFilterChange(e, 'truck')
                    }} optionLabel="label" optionValue='value' placeholder="Selecione um caminhão" />
                        <label>Caminhão</label>
                    </span>
                </div>
                <div className="field mt-2 lg:col-3">
                    <Button label="Filtrar" onClick={() => listDashboardInfo()} style={{ float: "right" }} icon="pi pi-filter" className="p-button-info" />
                </div>
            </div>
        </div>
    );

    useEffect(() => {
        listTrucks();
        setLoading(true);
        listDashboardInfo();
    }, []);

    if(loading)
        return (
            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "calc(100vh - 200px)",
                flexDirection: "column"
            }}>
                <ProgressSpinner style={{ width: 50 }} />
                <h5>Carregando dados...</h5>
            </div>
        )

    return (
        <div className="grid">
            <div className="col-12">
                <Filter />
            </div>
            <Information dashboardData={dashboardData} />
        </div>
    );
}

export default Dashboard;
